import React from "react";
import {
  Box,
  Button,
  Modal,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";

export default function ModalAlertaDuplicidade({
  open = false,
  onClose = () => {},
  onOpenTicket = () => {},
  onProceed = () => {},
  tickets = [],
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Modal open={open} onClose={onClose} sx={styles.modal}>
      <Box sx={{ position: "relative" }}>
        <Paper sx={styles.paper}>
          <Paper elevation={0} sx={styles.paperInterno}>
            <Box sx={styles.header}>
              {theme.palette.mode === "light" && (
                <Box sx={styles.circleWhiteMode} />
              )}
              <Box sx={styles.circleTransparent}>
                <Box sx={styles.circleFixed}>
                  <Typography sx={styles.typographyIcon}>!</Typography>
                </Box>
              </Box>

              <Typography variant="myTitle" sx={styles.title}>
                Atenção
              </Typography>
            </Box>

            <Box sx={styles.boxTextContent}>
              <Typography sx={styles.typographyText}>
                {tickets.length > 1
                  ? `Identificamos que já existem ${tickets?.length} atendimentos abertos para esta unidade com o mesmo tipo.`
                  : "Identificamos que já existe um atendimento aberto para esta unidade com o mesmo tipo."}
              </Typography>

              <Box sx={styles.ticketsListContainer}>
                {tickets.map((t) => (
                  <Box
                    key={t.id_atendimento || t.protocolo}
                    sx={styles.ticketCard}
                  >
                    <Typography variant="body2" sx={styles.protocolLabel}>
                      Protocolo:{" "}
                      <Typography
                        component="span"
                        onClick={() => onOpenTicket(t)}
                        sx={styles.protocolLink}
                      >
                        {t.protocolo}
                      </Typography>
                    </Typography>

                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={styles.dateText}
                    >
                      Data de abertura:{" "}
                      {t.data_cadastro
                        ? new Date(t.data_cadastro).toLocaleString("pt-BR")
                        : "-"}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            <Box sx={styles.boxButtons}>
              <Button
                variant="outlined"
                onClick={onClose}
                sx={styles.buttonVoltar}
              >
                Voltar
              </Button>

              <Button
                onClick={onProceed}
                variant="contained"
                sx={styles.buttonProsseguir}
              >
                Prosseguir
              </Button>
            </Box>
          </Paper>
        </Paper>
      </Box>
    </Modal>
  );
}
